export interface VenueTimingValue {
  checked?: boolean;
  endTime?: string;
  name?: string;
  startTime?: string;
}

export function isOvernightVenueTiming(
  startTime: string | null | undefined,
  endTime: string | null | undefined,
): boolean {
  return !!startTime && !!endTime && endTime !== "24:00" && endTime < startTime;
}

export function isVenueEndTimeDisabled(
  startTime: string | null | undefined,
  endTime: string,
): boolean {
  return !!startTime && startTime === endTime;
}

export function validateVenueTimings(timings: VenueTimingValue[]): string[] {
  const errors: string[] = [];
  timings.forEach((timing) => {
    if (!timing.checked) return;
    if (!timing.startTime || !timing.endTime) {
      errors.push(`${timing.name}: Missing start or end time`);
    } else if (timing.startTime === timing.endTime) {
      errors.push(`${timing.name}: Start and end time cannot be the same`);
    }
  });
  return errors;
}
